import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class DocumentReviewerGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private tokens: TokenStorageService,
    private router: Router
  ) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const token = this.tokens.getAccessToken();
    const expiresAt = this.tokens.getAccessExpiresAt();
    const expired = expiresAt ? new Date(expiresAt).getTime() <= Date.now() : false;

    if (!token || expired) {
      this.auth.forceLogout(false);
      return of(this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } }));
    }

    return this.auth.getCurrentUser().pipe(
      map(user => {
        if (user && ['Admin', 'SuperAdmin', 'Compliance'].includes(user.role)) return true;
        return this.router.createUrlTree(['/not-authorized'], { queryParams: { returnUrl: state.url } });
      }),
      catchError(() => of(this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } })))
    );
  }
}
